export const COMPAL_MENU_ID = 'compal-menu';
export const COMPAL_MENU_ITEM_ID = `${COMPAL_MENU_ID}-item`;
export const COMPAL_MENU_GROUP_ID = `${COMPAL_MENU_ID}-group`;

export const COMMAND_BODY_TEST_ID = 'command-palette.ui.modal.body.command-body-container';
export const COMMAND_CONTAINER_ROW_TEST_ID = 'command-palette.ui.modal.body.command-container-row';
export const SEARCH_INPUT_TEST_ID = 'command-palette.ui.modal.header.search-input';

export const COMPAL_MENU_SCREEN_READER_ID = 'compal-menu-screen-reader';
